import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import Image from "../../components/image";
import Artistics from "./Artistics";
import Technics from "./Technics";
import Claim from "./Claim";
import Marquee from "../../components/marquee";
import { loadActiveOpenCalls } from "../../redux/actions/openCalls";

class OpenCalls extends Component {
    componentDidMount() {
        this.props.loadActiveOpenCalls();
    }

    _renderOpenCalls() {
        const { openCalls, match } = this.props;

        if (!openCalls) return null;

        let ordered = openCalls.sort((a, b) => a.order - b.order);

        return ordered.map((openCall) => {
            switch (openCall.type) {
                case "artistic":
                    return <Artistics type={match.params.type} />;
                case "technical":
                    return <Technics type={match.params.type} />;
                case "reclamar_tempo":
                    return <Claim type={match.params.type} />;
            }
        });
    }

    render() {
        const { openCallsData } = this.props;

        if (!openCallsData) return <div className="h-screen" />;

        return (
            <div>
                <Marquee backgroundColor={"bg-pink"} color={"blue"} />
                {this._renderOpenCalls()}
                {openCallsData.image && (
                    <div className="xl:hidden bg-orange">
                        <Image
                            url={openCallsData.image.url}
                            aspectRatio={"aspect-ratio-square"}
                        />
                    </div>
                )}
                {openCallsData.image && (
                    <div className="hidden xl:block bg-orange">
                        <Image
                            url={openCallsData.image.url}
                            aspectRatio={"aspect-ratio-9/5"}
                        />
                    </div>
                )}
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    locale: state.app.locale,
    openCallsData: state.pages.open_calls,
    openCalls: state.openCalls.data,
});

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(
        {
            loadActiveOpenCalls,
        },
        dispatch
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(OpenCalls);
